<ng-template #campaignOptionList let-virtualEventData="virtualEventData" let-selectedCampaign="selectedCampaign">
  <app-campaign-option-list [virtualEventData]="virtualEventData" [campaign]="selectedCampaign"></app-campaign-option-list>
</ng-template>

<ng-template #sillentAuction let-selectedCampaign="selectedCampaign">
  <ng-container [ngSwitch]="isSilentAuctionClosed(selectedCampaign)">
    <div *ngSwitchCase="true" class="silent-auction silent-auction--closed">Silent Auction Closed</div>
    <div *ngSwitchCase="false" class="silent-auction">
      <button
        class="btn btn--paybee btn--success btn--md"
        (click)="openCloseSilentAuctionDialog(selectedCampaign)"
      >Close Silent Auction</button>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="height$ | async as height">
  <div [ngStyle]="{'height.px': height}">
    <div class="campaign-option__list">
      <ng-container *ngIf="data$ | async as data">
        <ng-container *ngIf="selectedCampaign$ | async as selectedCampaign">
          <ng-container 
            *ngTemplateOutlet="isSilentAuction(selectedCampaign) ? sillentAuction: campaignOptionList;
              context: { virtualEventData: data, selectedCampaign: selectedCampaign }"
          ></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>